module.exports = __webpack_public_path__ + "static/Federation-840ed06e1d93803f1879a41cfb74abfa.svg";